import { render, staticRenderFns } from "./waiguan.vue?vue&type=template&id=09fb7f35&scoped=true"
import script from "./waiguan.vue?vue&type=script&lang=js"
export * from "./waiguan.vue?vue&type=script&lang=js"
import style0 from "./waiguan.vue?vue&type=style&index=0&id=09fb7f35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb7f35",
  null
  
)

export default component.exports